module.exports = __webpack_public_path__ + "static/logo-105101938b9bc43bbb9d3d13ea3bc630.svg";